<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13OzK1/tc-custom/9781399098335.jpg?1709609335009" alt="This image is the cover for the book Sex & Sexuality in Medieval England"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sex & Sexuality in Medieval England
      </h1>
      <p class="bookDescription body article font2">
        <b>“She incorporates stories from every rank of society, from monarchs to peasants between 1250 and 1450, to tell a sweeping tale of sex and sexuality.” —<i>Adventures of a Tudor Nerd</i></b><br/><br/><i>Sex and Sexuality in Medieval England</i> allows the reader a peek beneath the bedsheets of our medieval ancestors, in an informative and fascinating look at sex and sexuality in England from 1250 to 1450. It examines the prevailing attitudes towards male and female sexual behaviour, and the ways in which these attitudes were often determined by those in positions of power and authority. It also explores our ancestors’ ingenious, surprising, bizarre and often entertaining solutions to the challenges associated with maintaining a healthy sex life. This book will look at marriage, pre-marital sex, adultery and fornication, pregnancy and fertility, illegitimacy, prostitution, consent, same-sex relationships, gender roles and much more, to shed new light on the private lives of our medieval predecessors.<br/><br/><b>“Warner’s writing is engaging, and the book is full of little tidbits of information, backed up by impeccable source work.” —<i>Tudor Blogger</i></b><br/><br/><b>“Her style of writing is lovely and easy to follow, making it a real page-turner. I highly recommend the book.” —<i>Coffee &amp; Books</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kathryn Warner
      </h2>
      
      <p class="authorDescription body article">Kathryn Warner holds a BA and an MA with Distinction in medieval history and literature from the University of Manchester, and is the author of biographies about Edward II and his queen Isabella. Kathryn has had work published in the English Historical Review, has given a paper at the International Medieval Congress, and appeared in a BBC documentary. She runs a popular blog on Edward II and is an expert on Edward II, Isabelle of Castille and Richard II.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cb204d82